
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/scheduler/standalone-month-view",
      function () {
        return require("private-next-pages/x/api/scheduler/standalone-month-view.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/scheduler/standalone-month-view"])
      });
    }
  